import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AlignedGrid } from "../AlignedGrid";
import { GridContext } from "./context";
export var ScrollableGridItem = function ScrollableGridItem(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var queryClass = useContext(GridContext);
  return React.Children.map(children, function (child, rowIndex) {
    return /*#__PURE__*/React.createElement(AlignedGrid.Item, {
      className: [queryClass, className].join(' '),
      key: +rowIndex
    }, child);
  });
};
ScrollableGridItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};